module.exports = __webpack_public_path__ + "img/444.fb693387.png";